exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".progress-bar-red{background-color:#dc5f69}.progress-bar-yellow{background:linear-gradient(90deg,#f5e52a,#fff)}.progress-bar-orange{background:linear-gradient(270deg,orange,#fff)}.progress-bar-almost-done{background:linear-gradient(90deg,#78ec62,#fff)}.progress-bar-done{background-color:#4baf4d}.progress-bar{display:block;color:#000;border-radius:15px;padding:5px;text-align:center;box-shadow:0 6px 5px 0 #0000003f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-b1ab22e4!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/grid/ProgressBarComponent.vue
// module id = 930
// module chunks = 2